<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="auto">
    <div class="flex">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="form.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <div class="rightItem">
        <span class="text">数据全部可见</span>
        <el-switch
          v-model="form.dataFullVisibilityFlag"
          active-color="#13ce66"
          :active-value="2"
          :inactive-value="1"
        ></el-switch>
      </div>
    </div>

    <!-- <el-form-item prop="roleKey">
      <span slot="label">
        <el-tooltip content="控制器中定义的权限字符，如：@PreAuthorize(`@ss.hasRole('admin')`)" placement="top">
          <i class="el-icon-question"></i>
        </el-tooltip>权限字符
      </span>
      <el-input v-model="form.roleKey" placeholder="请输入权限字符" />
    </el-form-item>-->
    <!-- <el-form-item label="数据权限范围" prop="dataAurty">
      <el-select v-model="form.dataAurty" placeholder="请选择权限范围">
        <el-option
          v-for="item in dataAurtyStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>-->
    <!-- <el-form-item label="状态">
      <el-radio-group v-model="form.status">
        <el-radio v-for="item in roleStatus" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
      </el-radio-group>
    </el-form-item>-->

    <div class="Lrflex">
      <div class="left">
        <div>
          <span class="text">PC端</span>
          <el-checkbox @change="changeExpandAll" v-model="expandAll">展开/折叠</el-checkbox>
          <el-checkbox @change="allChecked" v-model="checkedFlag">全选/全不选</el-checkbox>
        </div>
        <div class="tree">
          <el-tree
            ref="tree"
            :data="pcArr"
            show-checkbox
            node-key="id"
            :expand-on-click-node="false"
            :props="defaultProps"
          ></el-tree>
        </div>
      </div>
      <div class="right">
        <div>
          <span class="text">小程序</span>
          <el-checkbox @change="changeExpandAll2" v-model="expandAll2">展开/折叠</el-checkbox>
          <el-checkbox @change="allChecked2" v-model="checkedFlag2">全选/全不选</el-checkbox>
        </div>
        <div class="tree">
          <el-tree
            ref="tree2"
            :data="wxArr"
            show-checkbox
            node-key="id"
            :expand-on-click-node="false"
            :props="defaultProps"
          ></el-tree>
        </div>
      </div>
    </div>
    <!-- <el-form-item label="菜单权限" class='permission'>
            <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">展开/折叠</el-checkbox>
            <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">全选/全不选</el-checkbox>
            <el-tree
                class="tree-border"
                :data="menuOptions"
                show-checkbox
                ref="menu"
                node-key="id"
                :default-checked-keys="form.menuIds"
                :check-strictly="!form.menuCheckStrictly"
                empty-text="加载中，请稍候"
                :props="defaultProps"
                :getCurrentKey="getCurrentKeys"
                @getCurrentKey="getCurrentKeys"
                @check-change="handleCheckChange"
            ></el-tree>
    </el-form-item>-->
    <el-form-item label="备注" label-width="50px">
      <el-input
        v-model="form.remark"
        type="textarea"
        placeholder="300字以内"
        show-word-limit
        :maxlength="300"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
/**
 *  引入 -- 方法
 *
 * */
// import { add, update, getListId } from '@/utils/utils'
// import { getTreeselect } from '@/api/system/menu'
// import {
//   updateRole,
//   getRole,
//   addRole,
//   roleMenuTreeselect,
// } from '@/api/system/role'
// import { menuListfun } from '@/api/system/ent'
/**
 *  引入 -- 组件
 *
 * */
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { getmenuList, saveRole, detailRole, updaterole } from '@/api/system/system'
export default {
  name: 'from',
  components: { Treeselect },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clickFlag: false,
      pcArr: [],
      wxArr: [],
      menuList: [],
      checkedFlag: false,
      checkedFlag2: false,
      expandAll: false,
      expandAll2: false,
      menuExpand: true, // 展开/折叠
      menuNodeAll: false, // 全选/全不选
      menuOptions: [], // 菜单列表
      menuCheckStrictly: true,

      defaultProps: {
        children: 'childrens',
        label: 'menuName',
      },
      // deptCheckStrictly: false,
      // menuCheckStrictly: false,
      form: {
        id: '',
        roleName: '',
        type: '',
        status: 0,
        menuIds: [],
        remark: '',
        dataFullVisibilityFlag: 1,
      }, // 修改或新增数据

      roleStatus: [
        {
          value: 0,
          label: '正常',
        },
        {
          value: 1,
          label: '停用',
        },
      ],
      // dataAurtyStatus: [
      //   {
      //     value: '1',
      //     label: '个人',
      //   },
      //   {
      //     value: '2',
      //     label: '所属部门',
      //   },
      //   {
      //     value: '3',
      //     label: '全部部门',
      //   },
      //   {
      //     value: '4',
      //     label: '所属项目（默认）',
      //   },
      //   {
      //     value: '5',
      //     label: '全部项目',
      //   },
      //   {
      //     value: '6',
      //     label: '全公司',
      //   },
      // ],
      pidRole: [],
      // 表单校验
      rules: {
        roleName: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
        // roleKey: [{ required: true, message: '权限字符不能为空', trigger: 'blur' }],

        // dataAurty: [
        //   {
        //     required: true,
        //     message: '数据权限范围不能为空',
        //     trigger: ['blur', 'change'],
        //   },
        // ],
        type: [{ required: true, message: '项目权限范围不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    reset() {
      this.form = { id: '', roleName: '', type: '', status: 0, menuIds: [], remark: '' }
      this.resetForm('form')
    },
    changeExpandAll(val) {
      this.expandAll = val
      var treeNodeList = this.$refs.tree.store._getAllNodes()
      for (var i = 0; i < treeNodeList.length; i++) {
        treeNodeList[i].expanded = this.expandAll
      }
    },
    changeExpandAll2(val) {
      this.expandAll2 = val
      var treeNodeList = this.$refs.tree2.store._getAllNodes()
      for (var i = 0; i < treeNodeList.length; i++) {
        treeNodeList[i].expanded = this.expandAll2
      }
    },
    allChecked(val) {
      console.log(this.pcArr)

      if (val) {
        var arr = []
        this.pcArr.forEach((d) => {
          arr.push(d.id)
        })
        this.$refs.tree.setCheckedKeys(arr)
      } else {
        this.$refs.tree.setCheckedKeys([])
      }
    },
    allChecked2(val) {
      if (val) {
        var arr = []
        this.wxArr.forEach((d) => {
          arr.push(d.id)
        })
        this.$refs.tree2.setCheckedKeys(arr)
      } else {
        this.$refs.tree2.setCheckedKeys([])
      }
    },
    submit(type, callback) {
      if (this.clickFlag) {
        return
      }
      const pcKeys = [...this.$refs.tree.getCheckedKeys(), ...this.$refs.tree.getHalfCheckedKeys()]
      const wxKeys = [...this.$refs.tree2.getCheckedKeys(), ...this.$refs.tree2.getHalfCheckedKeys()]
      this.form.menuIds = pcKeys.concat(wxKeys)
      console.log(this.form, '-------submit')

      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.clickFlag = true
          if (type == 'add') {
            saveRole(this.form)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  // this.tableData = res.data.items
                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          } else if (type == 'edit') {
            updaterole(this.form)
              .then((res) => {
                this.clickFlag = false
                if (res.flag) {
                  // this.tableData = res.data.items
                  this.reset()
                  callback(true)
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch((error) => {
                this.clickFlag = false
                console.log(error)
              })
          }
        }
      })

      // return new Promise((resolve, reject) => {
      //   this.$refs['form'].validate((valid) => {
      //     const pcKeys = [...this.$refs.tree.getCheckedKeys(), ...this.$refs.tree.getHalfCheckedKeys()]
      //     const wxKeys = [...this.$refs.tree2.getCheckedKeys(), ...this.$refs.tree2.getHalfCheckedKeys()]
      //     this.form.menuIds = pcKeys.concat(wxKeys)
      //     if (valid) {
      //       let that = this
      //       let query = {
      //         url: '/system/role',
      //         data: this.form,
      //       }
      //       if (this.isEdit) {
      //         update(query, that, function (data) {
      //           resolve()
      //         })
      //       } else {
      //         add(query, that, function (data) {
      //           resolve()
      //         })
      //       }
      //     } else {
      //       reject(new Error('error'))
      //     }
      //   })
      // })
    },

    // 新增
    getData() {
      // 新增清空上次的勾选
      this.resetForm('form')
      this.checkedFlag = false
      this.checkedFlag2 = false
      this.$refs.form.clearValidate()
      this.$refs.tree.setCheckedKeys([])
      this.$refs.tree2.setCheckedKeys([])
      this.getMenuTreeselect()
    },
    async getListId(id) {
      await this.getMenuTreeselect()
      detailRole(id).then((res) => {
        console.log(res, '------------------')
        if (res.flag) {
          this.form = {
            id: res.data.id,
            roleName: res.data.roleName,
            type: '',
            status: res.data.status,
            menuIds: [],
            remark: res.data.remark,
            dataFullVisibilityFlag: res.data.dataFullVisibilityFlag,
          }

          console.log('默认勾选是激昂----------------')
          res.data.pcMenuIds.forEach((i) => {
            const pcNode = this.$refs.tree.getNode(i)
            // const wxNode = this.$refs.tree2.getNode(i);
            if (pcNode && pcNode.isLeaf) {
              this.$refs.tree.setChecked(pcNode, true)
            }

            // if (wxNode && wxNode.isLeaf) {
            //   this.$refs.tree.setChecked(wxNode, true);
            // }
          })

          res.data.appletMenuIds.forEach((i) => {
            // const pcNode = this.$refs.tree.getNode(i);
            const wxNode = this.$refs.tree2.getNode(i)
            // if (pcNode && pcNode.isLeaf) {
            //   this.$refs.tree.setChecked(pcNode, true);
            // }

            if (wxNode && wxNode.isLeaf) {
              this.$refs.tree2.setChecked(wxNode, true)
            }
          })
          // this.pcArr = res.data.pcMenuIds
          // this.wxArr = res.data.appletMenuIds
        }
      })
      // console.log('这个调用吗-*******************');
      // let that = this;
      // that.$refs.form.clearValidate();
      // let param = {
      //   url: '/system/role/' + id,
      // };
      // return new Promise((resolve, reject) => {
      //   getListId(param, function (data) {
      //     console.log(data, '------------------------------');
      //     that.form = {
      //       roleId: data.roleId,
      //       roleName: data.roleName,
      //       roleKey: data.roleKey,
      //       roleSort: data.roleSort,
      //       status: data.status,
      //       type: data.type,
      //       deptCheckStrictly: data.deptCheckStrictly,
      //       menuCheckStrictly: data.menuCheckStrictly,
      //       menuIds: data.menuIds,
      //       dataType: data.dataType,
      //       remark: data.remark,
      //       dataAurty: data.dataAurty
      //     };

      //     that.getMenuTreeselect(id);
      //     resolve(true);
      //   });
      // });
    },
    async getMenuTreeselect() {
      await getmenuList()
        .then((response) => {
          this.menuList = response.data.data
          // this.pcArr = this.GetTreeData(this.menuList.pc);
          // this.wxArr = this.GetTreeData(this.menuList.wx);

          console.log('显示的菜单---------------------------')
          this.wxArr = this.handleTree(
            response.data.filter((item) => item.type == 2),
            'id',
            'parentId',
            'childrens'
          )
          this.pcArr = this.handleTree(
            response.data.filter((item) => item.type == 1),
            'id',
            'parentId',
            'childrens'
          )
        })
        .catch((error) => {})
    },

    // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type == 'menu') {
        let treeList = this.menuOptions
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value
        }
      } else if (type == 'dept') {
        let treeList = this.deptOptions
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.dept.store.nodesMap[treeList[i].id].expanded = value
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type == 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions : [])
      } else if (type == 'dept') {
        this.$refs.dept.setCheckedNodes(value ? this.deptOptions : [])
      }
    },
    // 树权限（父子联动）
    handleCheckedTreeConnect(value) {
      this.menuCheckStrictly = value ? true : false
    },

    handleCheckChange(val) {
      let that = this
      let menuData = this.$refs.menu.getCheckedNodes()
      let parentData = this.$refs.menu.getHalfCheckedKeys()
      let menuIds = []
      menuData.some((item) => {
        if (menuIds.indexOf(item.id) < 0) {
          menuIds.push(item.id)
        }
      })
      that.pidRole = parentData
      this.form.menuIds = menuIds
    },
    getCurrentKeys(val) {},
  },
}
</script>

<style lang="less" scoped>
// @import '../../../../assets/styles/newDetails';
// @import 'src/assets/styles/form.scss';
.rightItem {
  margin-left: 55px;
  line-height: 36px;
  .text {
    margin-right: 10px;
  }
}
.flex {
  display: flex;
}
.Lrflex {
  display: flex;
  margin-bottom: 20px;
  .left {
    width: 50%;
    box-sizing: border-box;

    padding: 10px 20px;
    .tree {
      overflow: auto;
      margin-top: 20px;
      height: 336px;
      background: rgba(235, 239, 250, 0.4);
      border-radius: 12px;
      box-sizing: border-box;
      padding: 20px 20px;
    }
    .text {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #1e1f25;
      margin-right: 25px;
    }
  }
  .right {
    width: 50%;
    box-sizing: border-box;

    padding: 10px 0px;
    .tree {
      overflow: auto;
      margin-top: 20px;
      height: 336px;
      background: rgba(235, 239, 250, 0.4);
      border-radius: 12px;
      box-sizing: border-box;
      padding: 20px 20px;
      padding-bottom: 20px;
    }
    .text {
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #1e1f25;
      margin-right: 25px;
    }
  }
}
</style>
